const vehicleTestMode = require('../../data/testMode/vehicleInfo.json');

export default {
  namespaced: true,

  state: {
    // 車種情報
    vehicleInfo: null,
    // システムテーブル情報(ECU一覧テーブル情報)
    systemTable: null,
    // システムツリー情報(ECU一覧ツリー情報)
    systemTree: {},
    // 公開・非公開ファイル一覧の表示モード
    showPublished: true,
    // ダイアログのメッセージキャッシュ
    dialogContents: null,
    // 法規不適合システム一覧
    unconformedSystems: [],
    // プロジェクト一覧のキャッシュ
    projectListBuff: {},
    // 計測データのキャッシュ
    projectDetails: null,
    // FFD データのキャッシュ
    ffdStores: [],
    // BMD データのキャッシュ
    bmdStores: [],
    // 詳細FD データのキャッシュ
    detailFdStores: [],
    // リプロ対象ECUのROMID情報
    systemIdsInfo: { currentId: null, newIds: [] },
    // CCUリプロの情報
    ccuReproInfo: { systemName: null, newSwid: null, usbSwid: null, fileType: null, fileId: null },
    // データ再生画面で選択中の計測データをキャッシュ
    activeMeasuredDataId: '',
    // カスタムデータのキャッシュ
    cstmStores: null,
    // 通常画面・機能向上画面・以前バージョン画面のフラグ
    showDisplayVehicle: 'campaign',
    // ポップアップメニュー遷移前画面のキャッシュ(遷移前画面情報として、previousName, queryName, params を設定)
    popUpMenuPreviousStores: null,
    // ツリー開閉状態
    isTreeViewOpen: false, 
    // テストモード用に選択されたファイルをキャッシュ
    testModeSelectFile: null,
    //入力したシリアル番号をキャッシュ
    serialNumber: null,
    //選んだ商品コードに対応した商品情報をキャッシュ
    merchandiseInfo: { published: null, unpublished: null },
    //選んだ商品コードの情報をキャッシュ
    selectMerchandiseInfo: null,
    // アップデートプログラムの一覧をキャッシュ
    updateProgramInfo: { publishedTableItems: null, unpublishedTableItems: null },
    // アップデートプログラムの一覧画面に遷移する前のテーブルの状態をキャッシュする
    beforeTransitionTable: { published: null, unpublished: null },
    // 計測データの取得元の環境(マスター/ミラー)
    projectDataSource: '',
    // 実行系⇒プロジェクト画面への遷移済フラグ
    isMovedVehicleToProject: false,
    // ブラウザ戻る/進む遷移(popstate)判定フラグ
    isPopstateNavigation: false,
  },

  mutations: {
    // 車種情報
    setVehicle(state, payload) {
      state.vehicleInfo = payload;
    },
    // システムテーブル情報(ECU一覧テーブル情報)
    setSystemTable(state, payload) {
      state.systemTable = payload;
    },
    // システムツリー情報(ECU一覧ツリー情報)
    setSystemTree(state, payload) {
      if (payload !== null) {
        state.systemTree[payload.type] = payload.tbl;
      }
    },
    // 公開・非公開ファイル一覧の表示モード
    setDisplayMode(state, payload) {
      state.showPublished = payload;
    },
    setUnconformedSystems(state, payload) {
      state.unconformedSystems = payload;
    },
    // リプロ対象ECUのROMID情報
    setSystemIdsInfo(state, payload) {
      state.systemIdsInfo = payload;
    },
    // CCUリプロの情報
    setCcuReproInfo(state, payload) {
      state.ccuReproInfo = payload;
    },
    setDiagProjectList(state, payload) {
      state.projectListBuff = payload;
    },
    setProjectDetails(state, payload) {
      state.projectDetails = payload;
    },
    setFFDStores(state, payload) {
      state.ffdStores = payload;
    },
    setBmdStores(state, payload) {
      state.bmdStores = payload;
    },
    setDetailFdStores(state, payload) {
      state.detailFdStores = payload;
    },
    setActiveDataId(state, payload) {
      state.activeMeasuredDataId = payload;
    },
    // vin情報
    setVin(state, payload) {
      state.vehicleInfo.vehicle.vin.vin = payload;
    },
    setCstmStores(state, payload) {
      state.cstmStores = payload;
    },
    // 通常画面・機能向上画面・以前バージョン画面のフラグ
    setDisplayVehicleMode(state, payload) {
      state.showDisplayVehicle = payload;
    },
    setPopUpMenuPreviousStores(state, payload) {
      state.popUpMenuPreviousStores = payload;
    },
    /**
     * ツリー開閉状態をセットする。
     * @param {object} state 現在の State
     * @param {String} payload Payload
     */
    setIsTreeViewOpen(state, payload) {
      state.isTreeViewOpen = payload;
    },

    setSelectTestModeFileData(state, payload) {
      state.testModeSelectFile = payload;
    },
    setSerialNumber(state, payload) {
      state.serialNumber = payload;
    },
    setMerchandiseInfo(state, payload) {
      state.merchandiseInfo = payload;
    },
    setUpdateProgramInfo(state, payload) {
      state.updateProgramInfo = payload;
    },
    setSelectMerchandiseInfo(state, payload) {
      state.selectMerchandiseInfo = payload;
    },
    setBeforeTransitionTable(state, payload) {
      state.beforeTransitionTable = payload;
    },
    // 直近の検索結果一覧の取得元の環境(マスター/ミラー)を保持する
    setProjectDataSource(state, payload) {
      state.projectDataSource = payload;
    },
    setIsMovedVehicleToProject(state, payload) {
      state.isMovedVehicleToProject = payload;
    },
    setIsPopstateNavigation(state, payload) {
      state.isPopstateNavigation = payload;
    },
  },

  actions: {
    cacheVehicleInfo(context, payload) {
      let obj = null;
      if (payload) {
        // 参照渡しをしないためコピーを実施
        obj = JSON.parse(JSON.stringify(payload));
        if (context.rootState.netAppConnector.isTestMode) {
          obj.vehicle = vehicleTestMode.vehicle;
        } else {
          if (Object.prototype.hasOwnProperty.call(obj.vehicle, 'battery_voltage')) {
            // battery_voltage key が存在した場合削除しておく 
            delete obj.vehicle['battery_voltage'];
          }
        }
      }
      context.commit('setVehicle', obj);
    },

    cacheSystemTable(context, payload) {
      context.commit('setSystemTable', payload);
    },

    cacheSystemTree(context, payload) {
      context.commit('setSystemTree', payload);
    },

    cacheDisplayMode(context, payload) {
      context.commit('setDisplayMode', payload);
    },

    cahceUnconformedSystems(context, payload) {
      context.commit('setUnconformedSystems', payload);
    },

    cacheSystemIdsInfo(context, payload) {
      context.commit('setSystemIdsInfo', payload);
    },

    cacheCcuReproInfo(context, payload) {
      context.commit('setCcuReproInfo', payload);
    },

    cacheUnconformedSystems(context, payload) {
      context.commit('setUnconformedSystems', payload);
    },

    cacheDiagProjectList(context, payload) {
      context.commit('setDiagProjectList', payload);
    },

    cacheProjectDetails(context, payload) {
      context.commit('setProjectDetails', payload);
    },

    cacheFFDStores(context, payload) {
      context.commit('setFFDStores', payload);
    },

    cacheBmdStores(context, payload) {
      context.commit('setBmdStores', payload);
    },

    cacheDetailFdStores(context, payload) {
      context.commit('setDetailFdStores', payload);
    },

    cacheActiveDataId(context, payload) {
      context.commit('setActiveDataId', payload);
    },

    cacheVin(context, payload) {
      context.commit('setVin', payload);
    },

    cacheCstmStores(context, payload) {
      context.commit('setCstmStores', payload);
    },

    cacheDisplayReproTypeMode(context, payload) {
      context.commit('setDisplayVehicleMode', payload);
    },

    cachePopUpMenuPreviousStores(context, payload) {
      context.commit('setPopUpMenuPreviousStores', payload);
    },
    cacheProjectDataSource(context, payload) {
      context.commit('setProjectDataSource', payload);
    },

    /**
     * ツリー開閉状態を更新する
     * @param {object} context コンテキスト
     * @param {String} arg ツリー開閉状態
     */
    cacheIsTreeViewOpen(context, arg) {
      context.commit("setIsTreeViewOpen", arg);
    },
    cacheSelectTestModeFileData(context, payload) {
      context.commit('setSelectTestModeFileData', payload);
    },
    cacheSerialNumber(context, payload) {
      context.commit('setSerialNumber', payload);
    },
    cacheMerchandiseInfo(context, payload) {
      context.commit('setMerchandiseInfo', payload);
    },
    cacheUpdateProgramInfo(context, payload) {
      context.commit('setUpdateProgramInfo', payload);
    },
    cacheSelectMerchandiseInfo(context, payload) {
      context.commit('setSelectMerchandiseInfo', payload);
    },
    cacheBeforeTransitionTable(context, payload) {
      context.commit('setBeforeTransitionTable', payload);
    },
    cacheIsMovedVehicleToProject(context, payload) {
      context.commit("setIsMovedVehicleToProject", payload);
    },
    cacheIsPopstateNavigation(context, payload) {
      context.commit('setIsPopstateNavigation', payload);
    },
  }
};
